export const TURNOS = ['TODOS', 'PPT', 'PTM', 'PT', 'PTV', 'PTN', 'COR'];
export const POSICOES = ['TODAS', '1', '2', '3', '4', '5'];
// Faixa estendida (6º e 7º prêmio existem nas duas fontes) — usada na página de estatísticas
export const POSICOES_7 = ['TODAS', '1', '2', '3', '4', '5', '6', '7'];

export const PERIODS = [
  { value: '7', label: '7 dias' },
  { value: '15', label: '15 dias' },
  { value: '30', label: '30 dias' },
  { value: '90', label: '90 dias' },
  { value: '180', label: '6 meses' },
  { value: '365', label: '1 ano' },
  { value: '9999', label: 'Todos' },
];

export const SORTEIOS_OPTIONS = [
  { value: '50', label: 'Últimos 50' },
  { value: '100', label: 'Últimos 100' },
  { value: '200', label: 'Últimos 200' },
  { value: '500', label: 'Últimos 500' },
  { value: '9999', label: 'Todos' },
];

export const animalNames: Record<number, string> = {
  1: 'Avestruz', 2: 'Águia', 3: 'Burro', 4: 'Borboleta', 5: 'Cachorro',
  6: 'Cabra', 7: 'Carneiro', 8: 'Camelo', 9: 'Cobra', 10: 'Coelho',
  11: 'Cavalo', 12: 'Elefante', 13: 'Galo', 14: 'Gato', 15: 'Jacaré',
  16: 'Leão', 17: 'Macaco', 18: 'Porco', 19: 'Pavão', 20: 'Peru',
  21: 'Touro', 22: 'Tigre', 23: 'Urso', 24: 'Veado', 25: 'Vaca'
};

export const animalEmojis: Record<number, string> = {
  1: '🦩', 2: '🦅', 3: '🫏', 4: '🦋', 5: '🐕',
  6: '🐐', 7: '🐏', 8: '🐪', 9: '🐍', 10: '🐇',
  11: '🐴', 12: '🐘', 13: '🐓', 14: '🐱', 15: '🐊',
  16: '🦁', 17: '🐒', 18: '🐷', 19: '🦚', 20: '🦃',
  21: '🐂', 22: '🐅', 23: '🐻', 24: '🦌', 25: '🐄'
};

export const CHART_COLORS = [
  'hsl(var(--primary))', 'hsl(var(--chart-1))', 'hsl(var(--chart-2))',
  'hsl(var(--chart-3))', 'hsl(var(--chart-4))', 'hsl(var(--chart-5))',
];

export interface ResultRow {
  data: string;
  turno: string;
  posicao: number;
  milhar: string;
  grupo: number;
}

export const getGrupoFromMilhar = (milhar: string): number => {
  const last2 = parseInt(milhar.slice(-2));
  return last2 === 0 ? 25 : Math.floor((last2 - 1) / 4) + 1;
};
